// 示例
// function inviteFriend() {
//   let data = {
//     type:1
//   }
//   shareFriend.postMessage(JSON.stringify(data));
// }

/**
 * 年审订单支付
 * @param ordernum 订单号
 * @param payUrl 支付地址
 */
function aavOrderPay(ordernum) {
  const PAY_URL = '/v1/payExamineOrder';
  let url = `pages/pay/pay?orderid=${ordernum}&url=${PAY_URL}`;
  let data = {
    applets: url
  }
  pay.postMessage(JSON.stringify(data));
}

export {
  aavOrderPay,
}
